<template>
  <div class="counter-wrap" :class="{ dark: dark }">
    <div id="watched_counter" />
    <v-container>
      <v-row align="center" justify="center" class="root">
        <v-col v-for="(item, index) in data" :key="index" sm="6" md="3" cols="12">
          <div class="counter-item">
            <span :class="['icon', 'mdi', item.icon]" />
            <div class="text">
              <h4 class="display-1" v-if="loaded">
                +
                <span v-countUp:onWindowScroll.once="{
                  watchedElId: 'watched_counter',
                  startValue: 0,
                  endValue: item.value,
                  options: { duration: 1 }
                }" />
              </h4>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<style scoped lang="scss">
@import './counter-style';
</style>

<script>
export default {
  data: () => ({
    loaded: false
  }),
  mounted() {
    this.loaded = true
  },
  props: {
    dark: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => [

      ]
    }
  }
}
</script>
